import { basicSetup, EditorView } from 'codemirror';
import { EditorState } from '@codemirror/state';
import { sql } from '@codemirror/lang-sql';

// import { isValueExist } from '@/utils/utils';

import * as S from '../style';
// import StatusInput from '@/components/Common/StatusInput';
// import { ExportDataService } from '@/services';
// import { mapMutations } from 'vuex';

import { linter } from '@codemirror/lint';

const DEFAULT_EMPTY_LINE_NUMS = 60;

function sqlLinter(view) {
    let diagnostics = [];
    const doc = view.state.doc.toString();

    // 간단한 SQL 구문 검사 예제
    // if (/SELECT\s+.+\s+FROM\s+.+/i.test(doc) === false) {
    //     diagnostics.push({
    //         from: 0,
    //         to: doc.length,
    //         severity: 'error',
    //         message: "SQL 구문 오류: 'SELECT' 문은 'FROM' 절이 필요합니다.",
    //     });
    // }

    return diagnostics;
}

export default {
    name: 'SQLEditor',
    props: {
        queryString: {
            type: String
        },
        // fields: {
        //   type: Array,
        //   default: []
        // },
        // breakdowns: {
        //     type: Array,
        //     default: []
        // }
    },
    data() {
        return {
            editorView: null
        };
    },
    methods: {
        updateToMinNumberOfLines(minNumOfLines = DEFAULT_EMPTY_LINE_NUMS) {
            const currentNumOfLines = this.editorView.state.doc.lines;
            const currentStr = this.editorView.state.doc.toString();
            if (currentNumOfLines >= minNumOfLines) {
                return;
            }
            const lines = minNumOfLines - currentNumOfLines;
            const appendLines = '\n'.repeat(lines);
            this.editorView.dispatch({
                changes: { from: currentStr.length, insert: appendLines },
            });
        },
        // updateEditor(value) {
        //     if (!this.editorView) return;
        
        //     const changes = {
        //         from: 0,
        //         to: this.editorView.state.doc.length,
        //         insert: value || '', // Ensure fallback to an empty string
        //     };
    
        //     this.editorView.dispatch({ changes });
        // },
    },
    mounted() {
        if (!this.$refs.editor) return;

        const updateListener = EditorView.updateListener.of((update) => {
            if (update.docChanged) {
                this.$emit('setCode', update.state.doc.toString());
            }
        });

        const state = EditorState.create({
            doc: this.queryString,
            extensions: [
                basicSetup,
                sql({
                    upperCaseKeywords: true,
                }),
                linter(sqlLinter),
                updateListener,
            ],
        });

        this.editorView = new EditorView({
            state,
            parent: this.$refs.editor,
        });

        this.updateToMinNumberOfLines();
    },
    beforeDestroy() {
        if (this.editorView) {
          this.editorView.destroy();
        }
    },
    render() {
        return (
            <S.EditorWrapper>
                <div ref="editor" class="editor" />
            </S.EditorWrapper>
        );
    }
};
